import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import { useForm } from 'react-hook-form'
import { currentDate } from 'utils/helpers'
import { makePostRequest } from 'utils/api'
import CustomButton from 'Components/CustomButton/CustomButton'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'

export default function CreateDocForm({ setNewRows, mid }) {
  const [open, setOpen] = useState(false)
  const [types, setTypes] = useState([])
  const [file, setFile] = useState(null)

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Type: '',
      Nom: '',
      Description: '',
      Externe: '',
      Datedéchéance: currentDate(),
    },
  })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setFile(null)
  }

  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('Lien', file)
    formData.append('message_id', mid)

    const response = await makePostRequest(
      '/api/inbox/message/attachment/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 200) {
      let result = response.data

      setNewRows((newRows) => {
        return [...newRows, result]
      })

      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Add Document</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Ajouter Document</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                filename={file}
                required={true}
                // accept="application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
